import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router-dom';
import styled from '@emotion/styled';
import {
  CommonLayout,
  StyledContentContainer,
  StyledTitle,
  StyledText,
  StyledLink,
  StyledEmailSentLogo,
  StyledToast,
  SniperLink,
} from '@selfserve/react-ui';
import { buttonIds } from '@selfserve/react-utils';
import { useEmailResend } from '@selfserve/react-hooks';
import { withErrorHandling } from '@selfserve/react-hocs';
import { LoginByEmailPayload, useLoginByEmailRequest } from '../data';

const StyledCheckYourInboxContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const StyledCheckYourInboxText = styled(StyledText)(
  ({ theme }: { theme?: any; }) => ({
    marginTop: theme.spacing(2),
    display: 'flex',
    whiteSpace: 'pre',
    [theme.breakpoints.down('sm')]: {
      display: 'grid',
      whiteSpace: 'initial',
    },
  })
);

export const CheckYourInbox = withErrorHandling(
  ({ openErrorModal }) => {
    const { t } = useTranslation();
    const [searchParams] = useSearchParams();
    const productFamily = searchParams.get('productFamily') || undefined;
    const { removeSuccessMessage, onClickHandle, successMessage, email } =
      useEmailResend<LoginByEmailPayload, any>(openErrorModal, useLoginByEmailRequest, true, productFamily);

    return (
      <>
        {successMessage && (
          <StyledToast onClose={removeSuccessMessage} severity="success">
            <span>{successMessage}</span>
          </StyledToast>
        )}
        <CommonLayout>
          <StyledContentContainer centered>
            <StyledEmailSentLogo className="email-sent-logo" />
            <StyledCheckYourInboxContentContainer>
              <StyledTitle as="span" className="main-header" centered>
                {t('common.check-your-inbox')}
              </StyledTitle>
              <StyledCheckYourInboxText isSmall centered>
                {t('common.check-your-email-for-login')}
              </StyledCheckYourInboxText>
              <StyledCheckYourInboxText isSmall centered>
                {`${t('common.cant-find-email')} `}
                <StyledLink
                  to=""
                  onClick={onClickHandle}
                  id={buttonIds.resendVerification}
                >
                  {t('common.resend')}
                </StyledLink>
              </StyledCheckYourInboxText>
              <SniperLink email={email} />
            </StyledCheckYourInboxContentContainer>
          </StyledContentContainer>
        </CommonLayout>
      </>
    );
  }
);
